import { simpleFormNames, DefaultValue } from 'app/components/access-panel/default-values/panel-default-values-utils';
import { ComplexValue } from 'ui';

export const getDefaultValueFields = (values: DefaultValue[], formValues: { [key: string]: ComplexValue<number> }) => {

  if (!values || !formValues || (values && !values.length) || (!formValues && Object.keys(formValues))) {
    return undefined;
  }

  const formDefaultValue = formValues && formValues[simpleFormNames.values];
  const formCaseTypeValue = formValues && formValues[simpleFormNames.caseTypes];
  const formOptionsCollectionsValue = formValues && formValues[simpleFormNames.optionsCollections];

  const defaultValue: DefaultValue = values && typeof values === 'object' && values.find(value => {
    const defaultValueValue = value && value.defaultValue && value.defaultValue.value;
    const caseTypeValue = value && value.caseType && value.caseType.value;
    const optionsCollectionValue = value && value.optionsColection && value.optionsColection.value;

    const hasDefaultValue = defaultValueValue === (formDefaultValue && formDefaultValue.value);
    const hasCaseType = caseTypeValue === (formCaseTypeValue && formCaseTypeValue.value);
    const hasOptionsCollection = optionsCollectionValue === (formOptionsCollectionsValue && formOptionsCollectionsValue.value);

    return (!!hasDefaultValue && !!hasCaseType && !!hasOptionsCollection) ? value : undefined;
  });

  return !!defaultValue ? defaultValue.defaultValueFields : undefined;
};
